module.exports = __webpack_public_path__ + "fightIcon-9fbb788658704684944bfe51e9c91951.png";